import  { useEffect, useState } from "react";
import "./FifthReport.css";

const QTag = ({ q, a, impacts }) => (
  <div style={{display:'flex',flexWrap:'wrap',gap:'5px 10px',alignItems:'center',background:'#f0f4ff',border:'1px solid #c7d7fa',borderRadius:'6px',padding:'7px 12px',marginBottom:'12px',fontSize:'12px',lineHeight:1.5}}>
    <span style={{background:'#3b5bdb',color:'#fff',fontWeight:700,padding:'2px 8px',borderRadius:4,fontSize:'10px',whiteSpace:'nowrap'}}>📋 FORM QUESTION</span>
    <span style={{color:'#1e3a8a',fontStyle:'italic'}}>"{q}"</span>
    <span style={{color:'#6b7280',fontSize:'11px'}}>→</span>
    <span style={{color:'#047857',fontWeight:700}}>You answered: <strong>{a}</strong></span>
    <span style={{color:'#6b7280',fontSize:'11px'}}>→</span>
    <span style={{color:'#7c3aed',fontSize:'11px'}}>📊 Impacts: {impacts}</span>
  </div>
);

const FifthReport = ({ res }) => {
  const [competitionValue, setCompetitionValue] = useState("");
  const [competitorStageValue, setCompetitorStageValue] = useState("");
  const [segmentationValue, setSegmentationValue] = useState("");
  const [unfairValue, setUnfairValue] = useState("");
  const [coverageAreaValue, setCoverageAreaValue] = useState("");

  // Normalize backend values to lowercase
  useEffect(() => {
    setCompetitionValue((res.competition || "").toLowerCase());
    setCompetitorStageValue((res.competitorStage || "").toLowerCase());
    setSegmentationValue((res.segmentation || "").toLowerCase());
    setUnfairValue((res.unfairAdvantage || "").toLowerCase());
    setCoverageAreaValue((res.coverageArea || "").toLowerCase());
  }, [res]);

  // 4A: Unfair Advantage (all keys lowercase)
  const unfairData = {
    "ip": {
      advantage: "Proprietary IP / Tech",
      shortTerm: "Medium",
      longTerm: "Very High",
      investor: "🔥🔥 DeepTech, SaaS",
    },
    "network": {
      advantage: "Network Effect",
      shortTerm: "High",
      longTerm: "Very High",
      investor: "🔶 Top Priority",
    },
    "partnerships": {
      advantage: "Partnerships / Alliances",
      shortTerm: "High",
      longTerm: "Medium",
      investor: "📌 Early-Stage Traction",
    },
    "capital access": {
      advantage: "Funds Access",
      shortTerm: "Very High",
      longTerm: "Low",
      investor: "⚙ Operational but not a moat",
    },
    "brand / trust / data asset": {
      advantage: "Brand / Trust / Data Moat",
      shortTerm: "Medium",
      longTerm: "High",
      investor: "🌿 Scalable with user growth",
    },
    "regulatory license / compliance edge": {
      advantage: "Regulatory Licence / Compliance Edge",
      shortTerm: "Very High",
      longTerm: "Very High",
      investor:
        "💧 Strong Barrier — Ideal for FinTech, HealthTech, or RegTech investors",
    },
  };

  const selectedUnfair = unfairData[unfairValue] || null;

  // 4B: Competition (case insensitive)
  const competitionContent =
    competitionValue === "#yes"
      ? "A startup with healthy competition shows there’s a real market. What matters is how you differentiate and dominate your niche. You will study them closely, identify their weaknesses, and differentiate through unique value propositions, localized strategies, and superior customer experience — turning competition into an advantage."
      : "If no one else exists in this space, you have the big opportunity & prove people are ready for it. You will validate market demand, educate customers, and use your first-mover advantage to establish brand leadership before others enter the space.";

  // 4C: Competitor Stage (all lowercase keys)
  const competitorStageData = {
    "prototype": {
      strength: "Weak",
      focus: "Idea Validation & feasibility",
    },
    "validation": {
      strength: "Moderate",
      focus: "Market problem–solution fit",
    },
    "early traction": {
      strength: "Rising",
      focus: "Growth potential, adoption",
    },
    "scaling": {
      strength: "Strong",
      focus: "Execution power, go-to-market",
    },
    "mature/dominant": {
      strength: "Very Strong",
      focus: "Defensibility, moat, market share",
    },
  };

  const selectedCompetitorData = competitorStageData[competitorStageValue];

  // 4D: Coverage Area (lowercase)
  const coverageContent = {
    "same city / district":
      "Competitors operate in your immediate region, meaning demand is validated. You must differentiate through speed, service quality, and deeper customer understanding.",

    "state":
      "Competitors target statewide markets because of larger demand pockets. You should identify underserved cities and capture early leadership where competition is low.",

    "country":
      "National competitors operate at scale. Your strategy should focus on niche markets, hyperlocal execution, or strong regional dominance before expanding nationally.",

    "foreign":
      "Foreign competitors enter only high-value or mature markets. You should localize offerings, leverage cultural insights, and build trust to outperform global players.",
  };

  // 4E: Segmentation (case insensitive)
  const segmentationContent =
    segmentationValue === "$yes"
      ? "If competitors target the same client segment, we will differentiate through innovation, better service, and niche targeting to gain market share."
      : "If competitors target different segments, we will focus on unserved or underserved customers to build early leadership, validate new demand, and later expand strategically into adjacent segments.";


      const formatYesNo = (value) => {
  if (!value) return "";
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
};

  return (
    <>
    <QTag
      q="What is your startup's unfair competitive advantage? Does competition exist, and what geographic area do your competitors cover?"
      a={`Unfair edge: ${unfairValue || "—"} · Competition exists: ${competitionValue === "#yes" ? "Yes" : "No"} · Competitor stage: ${competitorStageValue || "—"} · Coverage: ${coverageAreaValue || "—"}`}
      impacts="Competitive moat defensibility, market validation signal, differentiation strategy, investor attractiveness"
    />
    <div>
      <div className="table-wrapper-with-corners">
        <div className="module5-title">
           <span className="module-prefix">Module 4:</span>  Competitive Edge Scan (Availability)
        </div>

        {/* 4A: Unfair Advantage */}
        {selectedUnfair && (
          <table className="fifth-module-table">
            <thead>
              <tr>
                <th>S.NO</th>
                <th>Unfair Advantage</th>
                <th>Short-Term Value</th>
                <th>Long-Term Defensibility</th>
                <th>Investor Preference</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="serial-cell">4 A</td>
                <td>{selectedUnfair.advantage}</td>
                <td>{selectedUnfair.shortTerm}</td>
                <td>{selectedUnfair.longTerm}</td>
                <td>{selectedUnfair.investor}</td>
              </tr>
            </tbody>
          </table>
        )}

        {/* 4B: Competition */}
        {competitionValue && (
          <table className="fifth-module-table">
            <tbody>
              <tr>
                <td className="serial-cell">4 B</td>
                <td>{formatYesNo(competitionValue === "#yes" ? "Yes" : "No")}</td>

                <td>{competitionContent}</td>
              </tr>
            </tbody>
          </table>
        )}

        {/* 4C: Competitor Stage */}
        {selectedCompetitorData && (
          <table className="fifth-module-table table-4c">

            <thead>
              <tr>
                <th>S.No</th>
                <th>Startup Phase</th>
                <th>Competitor Strength</th>
                <th>Investor Focus</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="serial-cell">4 C</td>
                <td>{res.competitorStage}</td>
                <td>{selectedCompetitorData.strength}</td>
                <td>{selectedCompetitorData.focus}</td>
              </tr>
            </tbody>
          </table>
        )}

        {/* 4D: Coverage Area */}
        {coverageAreaValue && (
          <table className="fifth-module-table">
            <tbody>
              <tr>
                <td className="serial-cell">4 D</td>
                <td>{res.coverageArea}</td>
                <td>{coverageContent[coverageAreaValue]}</td>
              </tr>
            </tbody>
          </table>
        )}

        {/* 4E: Segmentation */}
        {segmentationValue && (
          <table className="fifth-module-table">
            <tbody>
              <tr>
                <td className="serial-cell">4 E</td>
                <td>{formatYesNo(segmentationValue === "$yes" ? "Yes" : "No")}</td>

                <td>{segmentationContent}</td>
              </tr>
            </tbody>
          </table>
        )}

        {/* Corners */}
        <div className="corner top-left"></div>
        <div className="corner top-right"></div>
        <div className="corner bottom-left"></div>
        <div className="corner bottom-right"></div>
      </div>
    </div>
    </>
  );
};

export default FifthReport;
